import { merge } from 'lodash-es';

import { FormGroup } from '@angular/forms';
import { Injectable, TemplateRef } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ConfirmationModalComponent } from './confirmation-modal.component';

import { DEFAULT_CONFIG } from './util';
import { FuseConfirmationConfig } from '@fuse/services/confirmation';

export interface IConfirmationModalConfig extends FuseConfirmationConfig {
  primaryActionValue?: boolean;
  secondaryActionValue?: boolean;
  /**
   * Optional callback function that will be executed immediately when the user clicks the confirm button.
   * This function runs before the dialog closes, allowing you to perform actions like API calls,
   * state updates, or other operations directly from the confirmation modal.
   *
   * @example
   * const config: IConfirmationModalConfig = {
   *   title: 'Delete Item',
   *   message: 'Are you sure you want to delete this item?',
   *   onConfirm: () => {
   *     console.log('User confirmed deletion');
   *     // Perform deletion logic here
   *   }
   * };
   */
  onConfirm?: () => any;
  template?: {
    title?: string;
    value?: string;
    customTemplateForm?: FormGroup;
    templateRef?: TemplateRef<HTMLElement>;
    templateType: 'custom' | 'confirmInput' | 'checkbox' | 'slideToggle';
    secondaryAction?: {
      title?: string;
      value?: string;
      customTemplateForm?: FormGroup;
      templateRef?: TemplateRef<HTMLElement>;
      templateType: 'custom' | 'confirmInput' | 'checkbox' | 'slideToggle';
    };
  };
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmationModalService {
  private _defaultConfig: IConfirmationModalConfig = DEFAULT_CONFIG;

  /**
   * Constructor
   */
  constructor(private _matDialog: MatDialog) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  public open(config: IConfirmationModalConfig = {}): MatDialogRef<ConfirmationModalComponent> {
    // Merge the user config with the default config
    const userConfig = merge({}, this._defaultConfig, config);

    // Open the dialog
    return this._matDialog.open(ConfirmationModalComponent, {
      width: '600px',
      data: userConfig,
      autoFocus: false,
      disableClose: !userConfig.dismissible,
      panelClass: 'fuse-confirmation-dialog-panel',
    });
  }
}
